import { FlexRow, Text } from '@epam/promo';
import css from './ModalBody.module.scss';
import { ModalBodyProps } from './ModalBody.model';

const ModalBody = ({ text, highlight, bot, botImg }: ModalBodyProps) => {
  const [textStart, textEnd] = text.split(highlight ?? /$/);

  return (
    <>
      <img
        alt={bot === 'confirm' ? 'confirm bot' : 'delete bot'}
        className={css.modal__pic}
        src={botImg}
      />
      <FlexRow
        cx={
          bot === 'save'
            ? css['modal__description--save']
            : css.modal__description
        }>
        <Text color="gray80" font="sans" fontSize="16" lineHeight="24">
          {textStart}
          {highlight && textEnd && (
            <Text
              color="gray80"
              cx={css.modal__text}
              font="sans-semibold"
              fontSize="16"
              lineHeight="24">
              {highlight}
            </Text>
          )}
          {textEnd}
        </Text>
      </FlexRow>
    </>
  );
};

ModalBody.defaultProps = {
  highlight: undefined,
};

export { ModalBody };
